<template>
  <div
    class="action-button"
    :class="{ 'active': isActive, 'disabled': isDisabled, 'has-icon': data.icon }"
    v-ripple="$theme.whiteColorTransparent"
    @click="open"
  >
    <div class="icon-container">
      <i :class="data.icon" />
    </div>

    <p>{{ data.text }}</p>
  </div>
</template>

<script>
  export default {
    name: 'ActionButton',

    props: {
      data: {
        type: Object,
        default() {
          return {
            icon: 'icon-close',
            text: 'Action'
          };
        }
      },

      isActive: {
        type: Boolean,
        default: false
      },

      isDisabled: {
        type: Boolean,
        default: false
      }
    },

    methods: {
      open() {
        if (!this.isDisabled) {
          this.$emit('open');
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  .action-button {
    border: 1px solid #DADADA;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 0.5rem;
    cursor: pointer;
    min-height: 42px;

    &.disabled {
      background: #EFEFEF !important;
      opacity: 0.6;
      cursor: not-allowed;
    }

    &.active {
      border-color: $second-color;
      background: $second-color;
      color: $white-color;
    }

    &.has-icon {
      padding: 0.5rem;
      width: 90px;
      height: 56px;

      p {
        color: #333;
        font-size: 12px;
        margin-top: 0.3rem;
      }
    }

    .icon-container {
      color: #8E8E8E;
      text-align: center;

      i {
        font-size: 1.2rem;

        &.icon-align {
          font-size: 0.8rem;
        }
      }
    }

    p {
      font-size: 14px;
    }
  }
</style>
